export const isLocalEnvironment = (): boolean => {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV !== 'production';
  }

  const host = window.location.hostname || '';
  const isLocalHost =
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '::1' ||
    host.endsWith('.local');

  const forceLocal = process.env.REACT_APP_LOCAL_MODE === 'true';
  const isDevBuild = process.env.NODE_ENV === 'development';

  return isLocalHost || forceLocal || isDevBuild;
};

export const isHiddenFeatureEnabled = (): boolean => {
  return process.env.REACT_APP_ENABLE_HIDDEN_FEATURES === 'true';
};

export const allowHiddenFeatureForUser = (
  user?: {
    master?: number | boolean;
    is_admin?: number | boolean;
    email?: string;
    loginId?: string;
  } | null | undefined,
): boolean => {
  const email = `${user?.email || user?.loginId || ''}`.toLowerCase().trim();
  const isMasterAccount =
    user?.master === 1 ||
    user?.master === true ||
    user?.is_admin === 1 ||
    user?.is_admin === true ||
    email === 'master';

  if (isMasterAccount) return true;
  return isHiddenFeatureEnabled();
};
